import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ChangeUserPasswordResult, UserSettingsService } from '../../../core/services/user-settings.service';
import { userPasswordActions } from './user-password.actions';
import { map, switchMap } from 'rxjs';

@Injectable()
export class UserPasswordEffects {
  constructor(private actions$: Actions, private userSettingsService: UserSettingsService) {}

  passwordChangeStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(userPasswordActions.password_change_start),
        switchMap(data => {
          return this.userSettingsService.changeUserPassword(data.oldPassword, data.newPassword).pipe(
            map(status => {
              if (status === ChangeUserPasswordResult.Success) {
                return userPasswordActions.password_change_success();
              }

              return userPasswordActions.password_change_failure({ status });
            })
          );
        })
      ),
    { dispatch: true }
  );
}
